<template>
    <v-row
            v-if="appointment"
            dense>
        <v-col
                cols="12"
                dense>
            <v-radio-group
                    v-if="availablePaymentTypes.length"
                    v-model="selected"
                    :error="!!error"
                    :error-messages="error">
                <v-radio
                        v-for="(paymentType, index) in availablePaymentTypes"
                        :key="'payment-type-' + index"
                        class="question-payment-method-item"
                        active-class="selected"
                        :value="index"
                        @click="selected = index">
                    <template
                            v-slot:label>
                        <div class="d-flex flex-row align-center">
                            <img
                                    width="64px"
                                    height="40px"
                                    class="mr-2"
                                    :src="paymentType.icon">
                            <div>
                                <span class="subtitle-2">{{ paymentType.brand }}</span> <v-icon
                                        small
                                        class>
                                    mdi-circle-small
                                </v-icon> <span class="subtitle-2">{{ paymentType.last4 }}</span><br>
                                <span class="body-2">Expires: {{ paymentType.exp.month < 10 ? '0' + paymentType.exp.month : paymentType.exp.month }} / {{ paymentType.exp.year }}</span>
                            </div>
                        </div>
                    </template>
                </v-radio>
            </v-radio-group>
            <v-btn
                    dark
                    color="primary"
                    @click="addNewPaymentType = true">
                <v-icon left>
                    mdi-card-plus
                </v-icon> Add new payment method
            </v-btn>
        </v-col>
        <v-dialog
                v-model="addNewPaymentType"
                max-width="620">
            <v-card>
                <v-overlay
                        v-model="loading"
                        absolute>
                    <v-progress-circular
                            indeterminate
                            size="64" />
                </v-overlay>
                <v-card-title>{{ newPaymentType.name }}</v-card-title>
                <v-card-text>
                    <StripeMethodComponent
                            v-if="newPaymentType.type === 'stripe'"
                            ref="payment-method-component"
                            :show="addNewPaymentType"
                            :config="newPaymentType.config"
                            :three-ds="newPaymentType.threeDS"
                            :title="newPaymentType.name"
                            :consumer="consumerData"
                            @init="initHandle"
                            @loading="setLoading" />
                    <SageMethodComponent
                            v-if="newPaymentType.type === 'sage'"
                            ref="payment-method-component"
                            :show="addNewPaymentType"
                            :config="newPaymentType.config"
                            :three-ds="newPaymentType.threeDS"
                            :title="newPaymentType.name"
                            :consumer="consumerData"
                            @init="initHandle"
                            @loading="setLoading"
                            @error="addNewPaymentType = false" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                            dark
                            color="green"
                            @click="savePaymentMethod()">
                        Save
                    </v-btn>
                    <v-btn
                            text
                            @click="addNewPaymentType = false">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import Value from "@/models/value.model";
    import Field from "@/models/field.model";
    import StripeMethodComponent
        from "@/views/Form/components/components/components/components/StripeMethodComponent.vue";
    import SageMethodComponent from "@/views/Form/components/components/components/components/SageMethodComponent.vue";
    import PaymentTypeModel from "@/models/paymenttype.model";
    import Customer from "@/models/customer.model";

    export default {
        name: "FieldPaymentMethodComponent",
        components: {SageMethodComponent, StripeMethodComponent},
        props: {
            field: {type: Object, default: () => new Field()},
            consumer: {type: Object, default: () => {}}
        },
        data() {
            return {
                loading: false,
                value: null,
                error: null,
                selected: 0,
                addNewPaymentType: false,
                addedPaymentTypes: []
            }
        },
        computed: {
            appointment() {
                return this.$store.forms.getAppointment();
            },
            availablePaymentTypes() {
                if (!this.appointment) {
                    return [];
                }
                let that = this
                return [
                    ...this.appointment.payment_types.filter(e => e.type === 'existing')
                        .map(function (type) {
                            var paymentType = new PaymentTypeModel({
                                name: type.details.brand + ' ' + type.details.last4,
                                type: type.type,
                                token: type.token,
                                brand: type.details.brand,
                                exp: {year: type.details.expire_year, month: type.details.expire_month},
                                last4: type.details.last4
                            })
                            that.value = paymentType
                            return paymentType;
                        }),
                    ...this.addedPaymentTypes
                ];
            },
            newPaymentType() {
                return this.appointment.payment_types.find(e => e.type !== 'existing');
            },
            consumerData() {
                const consumer = new Customer(this.appointment.customer);
                consumer.set(
                    this.consumer.first_name,
                    this.consumer.last_name,
                    this.consumer.email,
                    this.consumer.phone
                );

                return consumer;
            },
        },
        watch: {
            selected() {
                this.error = null;
                this.value = this.availablePaymentTypes[this.selected]
            }
        },
        methods: {
            initHandle() {
                this.value = null;
                this.error = null;
            },
            setLoading(value) {
                this.loading = value
            },
            /**
             *
             * @returns {Value}
             */
            async savePaymentMethod() {
                const value = await this.$refs['payment-method-component'].submit()
                this.$nextTick(() => {
                    if (value !== null && value) {
                        this.addedPaymentTypes.push(value);
                        this.addNewPaymentType = false;
                        this.selected = this.availablePaymentTypes.length - 1;
                    }
                })

            },
            async getValue() {
                this.value = this.availablePaymentTypes[this.selected] || null;
                const value = new Value();

                if (this.value === false) {
                    value.value = null;
                    value.isValid = false;
                    value.error = 'Invalid card details';
                } else if (this.value === null && !this.field.is_optional) {
                    value.value = null;
                    value.isValid = false;
                    value.error = 'Mandatory field';
                } else {
                    if (this.value === null) {
                        value.value = {
                            type: 'existing',
                            name: null,
                            token: null
                        };
                        value.isValid = true;
                    } else {
                        value.value = this.value;
                        value.isValid = true;
                    }

                }

                this.$emit('updateValue', value);

                this.error = value.error
                return value;
            },

            isValid() {
                return true;
            },
        }
    }
</script>
<style>
.question-payment-method-item {
  border: solid 1px rgba(0, 0, 0, 0.12);
  padding: 14px 7px;
}

.question-payment-method-item.selected {
  border-color: #1976d273;
  box-shadow: 1px 1px 7px 1px #1976d266;
}

.question-payment-method-item label {
  display: block !important;
}
</style>